export default class DataIO {
    static POST(url, data = {}) {
        return this.Request(url, "POST", data);
    }

    static GET(url, params) {
        return this.Request(url, "GET", params);
    }

    static Request(url, method = "GET", params = {}) {
        return new Promise(function (resolve, reject) {
            var req = new XMLHttpRequest();

            req.onload = function () {
                if (req.status == 200) {
                    resolve(req.response);
                } else {
                    reject(Error(req.statusText));
                }
            };
            req.onerror = function () {
                reject(Error("Network Error"));
            };

            switch (method) {

                case "POST":
                    var urlParameters = DataIO.ObjectToParams(params);
                    if (urlParameters.length > 0) {
                        urlParameters = "?" + urlParameters;
                    }
                    req.open(method, url + urlParameters, true);
                    req.send();
                    break;

                case "GET":
                    var urlParameters = DataIO.ObjectToParams(params);
                    if (urlParameters.length > 0) {
                        urlParameters = "?" + urlParameters;
                    }
                    req.open(method, url + urlParameters, true);
                    req.send(DataIO.ObjectToParams(params));
                    break;

                default:
                    req.open(method, url, true);
                    req.send(DataIO.ObjectToParams(params));
                    break;
            }

        });
    }

    static ObjectToParams(params) {
        var newParams = "";
        var i = 0;
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                newParams += `${key}=${params[key]}&`
            }
        }
        return encodeURI(newParams.substr(0, newParams.length - 1));
    }
}



// WEBPACK FOOTER //
// ./src/Utils/DataIO.js